import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { Button } from '../../../components/common/Button/Button';
import { toggleConversionModal } from '../../../slices/portfolio-slice';
import { Box, Flexed } from '../../../styles/GlobalComponents';
import { color, lightTheme } from '../../../styles/GlobalStyles';
import { HandStarIcon, Icon } from '../../../styles/Icons';
import { getConversionInfo } from '../Portfolio.actions';
import { ConversionStepsEnum } from './types';
import { P1, P2 } from '../../../styles/FontStyles';
import { CheckText } from '../../../components/common/CheckText';

interface Step1Props {
  setConversionStep: Dispatch<SetStateAction<ConversionStepsEnum>>;
}

export const Step1 = ({ setConversionStep }: Step1Props) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation('my_hubs');

  const { conversionUserPackageId } = useAppSelector(
    (state) => state.portfolio
  );

  const handleCalculate = () => {
    if (conversionUserPackageId === null) return;
    dispatch(
      getConversionInfo({
        userPackageId: conversionUserPackageId,
        setConversionStep
      })
    );
  };

  return (
    <>
      <Box gray>
        <Flexed column center>
          <Flexed>
            <Icon mb='12'>
              <HandStarIcon />
            </Icon>
          </Flexed>
        </Flexed>
        <P1 bold center mb='20' color={lightTheme.colors.neutral500}>
          WHAT ARE LOYALTY POINTS?
        </P1>
        <P2 bold center mb='20'>
          YOU ARE TRYING TO CONVERT YOUR HUB NFT TO LOYALTY POINTS. LOYALTY
          POINTS CAN BE USED TO PURCHASE ANY BIGWHALE PRODUCT INSIDE THE MAVIE
          BACK-OFFICE.
          <br />
          <br />
          AFTER CONVERSION YOU WILL NO LONGER HAVE THE HUB NFT, BUT YOU WILL
          KEEP ALL ULX OR USDT COINS ALREADY PAID TO YOUR ACCOUNT.
        </P2>
        <P1 bold center mb='20' color={lightTheme.colors.primary900}>
          WITH THE CONVERSION TO LOYALTY POINTS:
        </P1>
        <CheckText
          checkColor={lightTheme.colors.success500}
          text={
            'You will receive loyalty points to spend on any BigWhale product.'
          }
        />
        <CheckText
          checkColor={lightTheme.colors.success500}
          text={
            'You will keep Personal Orders (PO) qualifications for ranks in the MaVie compensation plan.'
          }
        />
        <CheckText
          checkColor={lightTheme.colors.success500}
          text={
            'You will keep all already paid out coins from Hub NFT up to this point, funds already received do not need to be returned.'
          }
        />
        <CheckText
          x
          checkColor={lightTheme.colors.error500}
          text={
            'You will no longer have the Hub NFT and all its future rewards.'
          }
        />
        <CheckText
          checkColor={lightTheme.colors.success500}
          text={
            'All the Revenue Share Points will be transferred to the Revenue Pool of the BigWhale Product.'
          }
        />
      </Box>

      <Flexed>
        <Button
          mt='20'
          mr='10'
          negative
          onClick={() => dispatch(toggleConversionModal(false))}>
          Back to My Hubs
        </Button>
        <Button mt='20' ml='10' onClick={handleCalculate}>
          Calculate Loyalty Points
        </Button>
      </Flexed>
    </>
  );
};
